export const PAYMENT_SUCCESS_EVENT = 'paymentHasFinishedSuccessfully'
export const PAYMENT_FAIL_EVENT = 'paymentHasFailed'
